// extracted by mini-css-extract-plugin
export default {"table":"TableData_table__pVxsw"};